export default __webpack_public_path__ + "static/media/wear.9b5656f2.png";